// extracted by mini-css-extract-plugin
export default {"quizWrapper":"QuizContainer_quizWrapper__gwRm-","logoBig":"QuizContainer_logoBig__6jyxR"};